/**
 * Writing a CSV, in the one place both tiers can see.
 *
 * The server builds a segment's members into a file and the browser builds the
 * segments board into one. The escaping rule is the same in both, and a second
 * copy of it is the kind that goes wrong quietly: a name containing a comma —
 * "Smith, Jane" — shifts every later column by one, in a file somebody then
 * imports somewhere else and only notices weeks later.
 *
 * Pure, so it belongs here rather than in either adapter.
 */
/** A field, quoted only when it has to be. */
function csvField(value) {
    return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}
/** One row. */
function csvRow(values) {
    return values.map(csvField).join(',');
}
/**
 * A whole file: a header row and the rest.
 *
 * `\r\n` because that is what RFC 4180 says and what Excel expects; everything
 * that reads CSV copes with it, and not everything copes without it.
 */
export function csvFile(header, rows) {
    return [csvRow(header), ...rows.map(csvRow)].join('\r\n');
}
/**
 * Something a person named, as a filename.
 *
 * A segment is called whatever somebody typed; a filename has rules, and a
 * download whose name is empty or full of slashes is one the browser refuses or
 * mangles. Falls back rather than producing nothing.
 */
export function fileNamed(name, fallback) {
    return (name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || fallback);
}
//# sourceMappingURL=csv.js.map